// /src/App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PrivateRoute from './components/PrivateRoute';

import { BlogModalProvider } from './context/BlogModalContext';
import { SpinnerProvider } from './context/SpinnerContext';

import AdminDashboard from './components/AdminDashboard';

import HomePage from './pages/HomePage';
import RequestPasswordResetPage from './pages/RequestPasswordResetPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import BlogAdminPage from './pages/BlogAdminPage';
import LoginPage from './pages/LoginPage';
import BlogDashboardPage from './pages/BlogDashboardPage';
import PostLoginPage from './pages/PostLoginPage';
import CreateBlogPage from './pages/CreateBlogPage';
import NoBlogsPage from './pages/NoBlogsPage';
import ProfilePage from './pages/ProfilePage';

function App() {
  return (
    <BlogModalProvider>
      <SpinnerProvider>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/post-login" element={<PostLoginPage />} />
          <Route path="/request-password-reset" element={<RequestPasswordResetPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <ProfilePage />
              </PrivateRoute>
            }
          />

          <Route
            path="/platform-admin"
            element={
              <PrivateRoute requirePlatformAdmin>
                <AdminDashboard />
              </PrivateRoute>
            }
          />

          <Route
            path="/blog-admin"
            element={
              <PrivateRoute requirePerm="blog:manage_settings">
                <BlogAdminPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <BlogDashboardPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/platform/blogs/create"
            element={
              <PrivateRoute requirePlatformAdmin>
                <CreateBlogPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/no-blogs"
            element={
              <PrivateRoute>
                <NoBlogsPage />
              </PrivateRoute>
            }
          />

        </Routes>
      </SpinnerProvider>
    </BlogModalProvider>
  );
}

export default App;
